import * as roleApi from './api/index';
let modalHtml = '';
const isFunc = (func: Function) => Object.prototype.toString.call(func) === '[object Function]';
class Modal {
  public platid: 1 | 0 | '' = ''
  public partition: number | '' = ''
  public area: number | '' = ''
  public selectData: ServerSelect = {
    STD_CHANNEL_DATA: [],
    STD_DATA: [],
    STD_SYSTEM_DATA: [],
  }
  public checkboxFlag = false
  public isAuth: Boolean = false
  public isLoading: Boolean = false

  public SlugRoleSelector: SlugRoleSelectorClass
  public constructor(SlugRoleSelector: SlugRoleSelectorClass) {
    this.SlugRoleSelector = SlugRoleSelector;
  }
  public creatModal = (data: ServerSelect) => {
    this.area = '';
    this.platid = '';
    this.partition = '';
    if (this.isAuth) {
      this.checkboxFlag = true;
    }
    this.selectData = data;
    const modal = document.createElement('div');
    modal.setAttribute('class', 'game-tools-modal-wrap');
    modal.setAttribute('id', 'gameToolsModalWrap');
    this.handleTemplete(data);
    modal.innerHTML = modalHtml;
    document.body.appendChild(modal);
    this.bindEvent(modal);
  };

  public hideModal() {
    if (!document.getElementById('gameToolsModalWrap')) {
      throw '请先showModal';
    }
    document.body.removeChild(document.getElementById('gameToolsModalWrap') as HTMLElement);
  }


  private bindEvent = (modal: any) => {
    (modal.querySelector('.game-tools-close') as HTMLElement).addEventListener('click', () => {
      this.hideModal();
    });
    (document.getElementById('confirmGameRole') as HTMLElement).addEventListener('click', this.confirm.bind(this));

    modal.querySelector('.system_data select')
    && modal.querySelector('.system_data select').addEventListener('change', (e: any) => {
      this.platid = e.target.value;
      this.renderStdData();
      this.queryRole();
    });

    modal.querySelector('.channel_data select')
    && modal.querySelector('.channel_data select').addEventListener('change', (e: any) => {
      this.area = e.target.value;
      this.renderStdData();
      this.queryRole();
    });

    modal.querySelector('.std_data select')
    && modal.querySelector('.std_data select').addEventListener('change', (e: any) => {
      this.partition = e.target.value;
      this.queryRole();
    });
    if (!this.checkboxFlag) {
      this.setSelectDisabledAttr(false);
    }
    modal.querySelector('.game-tools-modal')
     && modal.querySelector('.game-tools-modal').addEventListener('touchstart', (e: any) => {
       if (e.target.tagName === 'SELECT' && !this.checkboxFlag && !this.isAuth) {
         alert('请先授权协议');
       }
     });

    modal.querySelector('.game-tools-empower input')
     && modal.querySelector('.game-tools-empower input').addEventListener('change', (e: any) => {
       this.checkboxFlag = e.target.checked;
       this.setSelectDisabledAttr(this.checkboxFlag);
     });


    modal.querySelector('#unbind-btn')
     && modal.querySelector('#unbind-btn').addEventListener('click', () => {
       if (this.isLoading) {
         return;
       }
       this.isLoading = true;
       const { afterUnBind } = this.SlugRoleSelector;
       const hasAfterUnBind = afterUnBind && isFunc(afterUnBind);

       this.SlugRoleSelector.unBindRole()
         .then((res: any) => {
           this.isLoading = false;
           if (res && res.code === 200) {
             hasAfterUnBind && afterUnBind(true);
             this.SlugRoleSelector.setAuth(0);
             this.isAuth = false;
             this.checkboxFlag = false;
             return;
           }
           throw '解绑失败';
         })
         .catch(() => {
           this.isLoading = false;
           console.log('解绑失败');
           hasAfterUnBind && afterUnBind(false);
         });
     });
  }
  private setSelectDisabledAttr(value: Boolean) {
    const selectList = document.querySelectorAll('.gt-form-item select');
    selectList.forEach((select) => {
      if (value) {
        select.removeAttribute('disabled');
      } else {
        select.setAttribute('disabled', 'true');
      }
    });
    if (value) this.renderStdData();
  }

  private handleTemplete(res: ServerSelect) {
    modalHtml = `<div class="game-tools-modal">
                  <div class="game-tools-close"></div>
                  ${this.isAuth ? ''
    : '<div class="game-tools-empower">\
                  <input type="checkbox"/>我同意授权“本公众号活动获取并存储我的游戏区服信息用于发奖”\
                </div>'}
                  ${this.handleSelect(res)}
                  <button id="confirmGameRole">确认</button>
                  ${this.isAuth ? '<div id="unbind-btn">解绑账号</div>' : ''}
                </div>`;
  }
  // <div id="qq-login-btn">切换QQ登录</div>
  private handleSelect(res: ServerSelect) {
    const systemHtml = `<div class="gt-form-item system_data">
                        <label>平台</label>
                        <select>${this.handleOptions('平台', res.STD_SYSTEM_DATA)}</select>
                      </div>`;
    const channelHtml =  `<div class="gt-form-item channel_data">
                          <label>大区</label>
                          <select>${this.handleOptions('大区', res.STD_CHANNEL_DATA)}</select>
                        </div>`;
    const stdHtml =  `<div class="gt-form-item std_data">
                        <label>小区</label>
                        <select disabled>${this.handleOptions('小区', this.handleStaData(res.STD_DATA))}</select>
                      </div>`;
    const roleHtml = `<div class="gt-form-item game_role">
                        <label>角色</label>
                        <select>
                          <option value="">请选择角色</option>
                        </select>
                      </div>`;
    return systemHtml + channelHtml + stdHtml + roleHtml;
  }

  private handleStaData(staData: any) {
    let rStaData: any = [];
    staData.forEach((data: any) => {
      // 端游区服有两级 需要扁平化
      if (data.opt_data_array) {
        rStaData = rStaData.concat(data.opt_data_array.filter((item: any) => item.display === '1'));
      } else if (data.display === '1' || data.display === undefined) {
        rStaData = rStaData.concat(data);
      }
    });
    return rStaData;
  }

  private handleOptions(optionTypeName: string, options: any) {
    let OptionsHtml = `<option value=''>请选择${optionTypeName}</option>`;
    return OptionsHtml += options.reduce((acc: string, cur: Option) => `${acc}<option value="${cur.v}">${cur.t}</option>`, '');
  }


  private renderStdData() {
    if (this.selectData.STD_DATA.length < 1) {
      return;
    }
    const stdSelector = document.querySelector('.std_data select') as HTMLSelectElement;
    if ((this.selectData.STD_CHANNEL_DATA.length && this.area === '')
      || (this.selectData.STD_SYSTEM_DATA.length && this.area === '')) {
      stdSelector.setAttribute('disabled', '');
      return;
    }
    stdSelector.removeAttribute('disabled');

    if (this.checkboxFlag) {
      stdSelector.removeAttribute('disabled');
    }


    let stdData = this.selectData.STD_DATA;
    if (this.area) {
      stdData = stdData
        .filter((item: any) => item.c === this.area);
    }
    if (this.platid) {
      stdData = stdData
        .filter((item: any) => item.s === this.platid);
    }
    stdSelector.innerHTML = this.handleOptions('小区', this.handleStaData(stdData));
  }
  private renderRoleData(roleList: any) {
    const gameRoleSelector = document.querySelector('.game_role select') as HTMLSelectElement;
    let roleSelectHtml = '';
    roleSelectHtml += roleList.reduce((acc: string, cur: any) => `${acc}<option value="${cur.token}">${cur.charac_name}</option>`, '');
    gameRoleSelector.innerHTML = roleSelectHtml;
  }

  private invalidSelect() {
    return (this.selectData.STD_CHANNEL_DATA.length && this.area === '')
      || (this.selectData.STD_SYSTEM_DATA.length && this.platid === '')
      || (this.selectData.STD_DATA.length &&  this.partition === '');
  }

  private queryRole() {
    if (this.invalidSelect()) return;
    const { area, platid, partition } = this;
    const params = {
      site: this.SlugRoleSelector.site,
      loginType: this.SlugRoleSelector.loginType,
      area,
      platid,
      partition,
    };
    const { afterQuery } = this.SlugRoleSelector;


    if (afterQuery && !isFunc(afterQuery)) {
      throw new ReferenceError('afterQuery must to be function');
    }

    roleApi.queryRole(params).then((res: any) => {
      this.renderRoleData(res.result);
      if (afterQuery) afterQuery(true, res.result);
    })
      .catch((err) => {
        console.log(err);
        if (afterQuery) afterQuery(false, err);
      });
  }

  private confirm() {
    if (this.isLoading) {
      return;
    }
    if (!this.checkboxFlag) {
      alert('请先授权协议');
      return;
    }

    if (this.invalidSelect()) {
      this.renderRoleData([]);
      return;
    }

    const gameRoleSelector = document.querySelector('.game_role select') as HTMLSelectElement;
    const token = gameRoleSelector?.value;
    const { afterBind } = this.SlugRoleSelector;

    // if (!afterBind) {
    //   throw new ReferenceError('建议传递afterBind绑定方法');
    // }

    if (afterBind && !isFunc(afterBind)) {
      throw new ReferenceError('afterBind must to be function');
    }

    if (!token) {
      if (afterBind) afterBind(false, '角色查询失败, 无token');
    } else {
      this.isLoading = true;
      this.SlugRoleSelector.bindRole(token)
        .then((res: any) => {
          this.isLoading = false;
          const characName = gameRoleSelector.options[gameRoleSelector.selectedIndex].text;
          if (res.code === 200) {
            try {
              if (afterBind) afterBind(true, {
                characName,
                area: this.area,
                platid: this.platid,
                partition: this.partition,
              });
              if (!this.isAuth) {
                this.SlugRoleSelector.setAuth(1);
                this.isAuth = true;
              }
            } catch (err) {
              console.error(err);
            }
          } else {
            if (afterBind) afterBind(false, res);
          }
        })
        .catch((err: any) => {
          this.isLoading = false;
          if (afterBind) afterBind(false, err);
        });
    }
  }
}
interface Option {
  v: number
  t: string
}


export default Modal;
